export const getUserId = state => {
  return state.User.user._id;
};
